import React from 'react';
import { useIntl } from 'react-intl-next';
import { Stack } from '@atlaskit/primitives/compiled';
import { everyoneElseAri } from '../../constants';
import { FormSupportedPrincipalType } from '../../types';
import { messages } from './messages';
import { PrincipalItem } from './principal-item';
export const PrincipalList = ({
  principals,
  isViewMode,
  removePrincipal
}) => {
  const {
    formatMessage
  } = useIntl();
  if (principals.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Stack, {
    space: "space.050",
    testId: "proforma-form-security.ui.config-button.config-modal.form-permissions-config.principal-list"
  }, /*#__PURE__*/React.createElement(PrincipalItem, {
    key: everyoneElseAri.toString(),
    principal: {
      ari: everyoneElseAri,
      type: FormSupportedPrincipalType.USER_GROUP,
      name: formatMessage(messages.everyoneElse)
    },
    isDisabled: true,
    isViewMode: isViewMode,
    removePrincipal: removePrincipal
  }), principals.map(principal => /*#__PURE__*/React.createElement(PrincipalItem, {
    key: principal.ari.toString(),
    principal: principal,
    canAccess: true,
    isViewMode: isViewMode,
    removePrincipal: removePrincipal
  })));
};